import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"error\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" /><mask id=\"error_a\" maskUnits=\"userSpaceOnUse\" x=\"1\" y=\"2\" width=\"22\" height=\"19\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" /></mask></symbol>"
});
var result = sprite.add(symbol);
export default symbol